var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassificationPlotsOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "#272D55",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 13H2C1.44772 13 1 13.4477 1 14V19C1 19.5523 1.44772 20 2 20H4C4.55228 20 5 19.5523 5 19V14C5 13.4477 4.55228 13 4 13Z",
    fill: "#AECDFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 13.5H2C1.72386 13.5 1.5 13.7239 1.5 14V19C1.5 19.2761 1.72386 19.5 2 19.5H4C4.27614 19.5 4.5 19.2761 4.5 19V14C4.5 13.7239 4.27614 13.5 4 13.5Z",
    stroke: "#272D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9H7C6.44772 9 6 9.44772 6 10V19C6 19.5523 6.44772 20 7 20H9C9.55228 20 10 19.5523 10 19V10C10 9.44772 9.55228 9 9 9Z",
    fill: "#AECDFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.5H7C6.72386 9.5 6.5 9.72386 6.5 10V19C6.5 19.2761 6.72386 19.5 7 19.5H9C9.27614 19.5 9.5 19.2761 9.5 19V10C9.5 9.72386 9.27614 9.5 9 9.5Z",
    stroke: "#272D55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5H12C11.4477 5 11 5.44772 11 6V19C11 19.5523 11.4477 20 12 20H14C14.5523 20 15 19.5523 15 19V6C15 5.44772 14.5523 5 14 5Z",
    fill: "#AECDFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.5H12C11.7239 5.5 11.5 5.72386 11.5 6V19C11.5 19.2761 11.7239 19.5 12 19.5H14C14.2761 19.5 14.5 19.2761 14.5 19V6C14.5 5.72386 14.2761 5.5 14 5.5Z",
    stroke: "#272D55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75098 6.99927L11.707 1.69922",
    stroke: "#272D55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6863 1.46104L12.2499 1.4608L10.8754 3.56296",
    stroke: "#272D55",
    strokeWidth: 1.99923,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassificationPlotsOperationIcon);
export default __webpack_public_path__ + "static/media/ClassificationPlotsOperationIcon.029827c4742b2003ee5dc60f6de4c449.svg";
export { ForwardRef as ReactComponent };